import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { RouteData, SiteData } from "react-static";

import Section from "../components/section";
import Seo from "../components/seo";
import Markdown from "../components/markdown";

const Questions = styled(Markdown)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-family: "Lyon", serif;
  font-size: 13pt;
  line-height: 1.5;
  margin-top: 2rem;
  margin-bottom: 8rem;
  h1 {
    font-weight: bolder;
    margin-top: 2rem;
  }
  p {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;
const FAQ = ({ copy, meta, siteData }) => (
  <Fragment>
    <Seo
      url="https://inotherwords.id/faq"
      siteTitle={siteData.data.title}
      pageTitle={meta.title}
      description={meta.description}
      image={meta.image}
      siteFBAppID={siteData.data.fbappid}
      userTwitter={siteData.data.twitter}
    />
    <Section title={(copy.data && copy.data.title) || "F.A.Q."}>
      <Questions source={copy.content} />
    </Section>
  </Fragment>
);

export default () => (
  <SiteData>
    {siteData => (
      <RouteData>
        {routeData => <FAQ {...routeData} siteData={siteData} />}
      </RouteData>
    )}
  </SiteData>
);
